var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSourceChamber(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg27397",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 247.05882 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "source-chamber",
    style: {
      display: "inline"
    },
    transform: "matrix(1.7647 0 0 1.7647 -677.46708 -342.62381)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#999",
      stroke: "#000",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect274-3-9-7",
    d: "M384.39807 194.65355h138.99988v168.99988H384.39807Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15021-17",
    style: {
      display: "inline",
      fill: "gray",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.78035,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    d: "m396.10699 200.17497-4.55078.0762-2.20703 3.97851 2.33985 3.90235 4.55078-.0762 2.20703-3.97851zm120 0-4.55078.0762-2.20703 3.97851 2.33985 3.90235 4.55078-.0762 2.20703-3.97851zm-120 150-4.55078.0762-2.20703 3.97851 2.33985 3.90235 4.55078-.0762 2.20703-3.97851zm120 0-4.55078.0762-2.20703 3.97851 2.33985 3.90235 4.55078-.0762 2.20703-3.97851z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceChamber);
export default __webpack_public_path__ + "static/media/source-chamber.d2c1738e5c09dbc703697d2e9ae10638.svg";
export { ForwardRef as ReactComponent };